import axios from 'axios';

const API_BASE_URL = '/api/question-types';

const questionTypesService = {
  // Get all question types with pagination and filters
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE_URL, {
      params,
      withCredentials: true
    });
    return response.data;
  },

  // Get single question type by ID
  getById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create new question type
  create: async (data) => {
    const response = await axios.post(API_BASE_URL, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Update question type
  update: async (id, data) => {
    const response = await axios.put(`${API_BASE_URL}/${id}`, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Delete question type
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/${id}`, {
      withCredentials: true
    });
    return response.data;
  }
};

export default questionTypesService;
